<div class="modalProgressbarCont">
  <app-progressbar *ngIf="showSpinner"></app-progressbar>
</div>


<div id="main" class="progressbarOffset">
  <div id="content">
    <div id="sideSection">
      <div class="panelHeader">
        {{'LOCATION' | translate}}
      </div>
      <div class="matAccordionCont">
        <mat-accordion multi="true">
          <mat-expansion-panel
            expanded="true">
            <mat-expansion-panel-header id="locationsCont" class="neutralHeader">
              {{'LOCATION' | translate}}
            </mat-expansion-panel-header>
            <div *ngIf="locations" class="locationNamesCont">
              <div *ngFor="let location of locations"
                   (click)="selectLocation(location, 'parent')"
                   class="locationName"
                   [ngClass]="selectedParentLocation && (selectedParentLocation.id === location.id) ? 'selected' : ''">
                {{location.name}}
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="selectedParentLocation && selectedParentLocation.children"
            [disabled]="!selectedParentLocation || !selectedParentLocation.children"
            (opened)="parentPanelExpanded = false">
            <mat-expansion-panel-header id="subLocationsCont" class="neutralHeader">
              {{'CHILD_LOCATION' | translate}}
            </mat-expansion-panel-header>
            <div *ngIf="selectedParentLocation && selectedParentLocation.children"
                 class="locationNamesCont">
              <div *ngFor="let childLocation of selectedParentLocation.children"
                   (click)="selectLocation(childLocation, 'child')"
                   class="locationName"
                   [ngClass]="selectedChildLocation && (selectedChildLocation.id === childLocation.id) ? 'selected' : ''">
                {{childLocation.name}}
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>

    <div id="mainSection">
      <div class="panelHeader">
        {{"OFFSET_SETTINGS"|translate}}
      </div>
      <div *ngIf="!selectedParentLocation">
        {{"NO_LOCATION_SELECTED"|translate}}
      </div>
      <mat-tab-group #tabGroup [(selectedIndex)]="index">
        <mat-tab label="Offset">
          <div class="matAccordionCont" *ngIf="selectedParentLocation">
            <app-offset-form (closeCallback)="matDialogRef.close()" [selectedLocation]="selectedLocation"
                             [dateStart]="data.dateStart" [offsetDate]="data.date" [offset]="data.offset"></app-offset-form>
          </div>
        </mat-tab>
        <mat-tab label="Erase">
          <div class="matAccordionCont" *ngIf="selectedParentLocation">
            <app-eraser-form [selectedLocation]="selectedLocation" [dateStart]="data.dateStart"
                             (showSpinner)="showSpinner = $event"></app-eraser-form>
          </div>
        </mat-tab>

        <mat-tab label="Threshold">
          <div class="matAccordionCont" *ngIf="selectedParentLocation">
            <app-threshold-form [locations]="locations" [selectedLocation]="selectedLocation" [dateStart]="data.dateStart" [dateEnd]="data.dateEnd"
                                (showSpinner)="showSpinner = $event" [idProject]="data.idProject" [(thresholdTable)]="thresholdTable"></app-threshold-form>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>
</div>
